import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "39.807",
  height: "34.474",
  viewBox: "0 0 39.807 34.474"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "2.609",
  height: "12.391",
  transform: "translate(18.6 12.43)",
  fill: "#ff453a"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  width: "2.609",
  height: "2.243",
  transform: "translate(18.6 27.43)",
  fill: "#ff453a"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.209,18.548,19.9,5.219,27.6,18.548l7.7,13.317H4.526ZM19.9,0,9.952,17.243,0,34.474H39.807l-9.952-17.23Z",
  fill: "#ff453a"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("rect", {
  width: "2.609",
  height: "12.391",
  transform: "translate(18.6 12.43)",
  fill: "#ff453a"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_6))
}